import Cookies from "js-cookie";
import { syncSessionExpiration } from "./sessionManager";
import { readPickedFranchise } from "./pickedFranchise";
import { roleGroups } from "./roleGroups";

if (typeof window !== "undefined") {
  syncSessionExpiration();
}

// REACT_APP_API_URL is set by `yarn dev` and scripts/deploy.sh; a plain build stays on production.
export const baseUrl = process.env.REACT_APP_API_URL || "https://live-api.foodoor.in";

// Extract protocol, host, and WebSocket protocol dynamically from baseUrl
const parsedUrl = new URL(baseUrl);
export const protocol = parsedUrl.protocol + "//";
export const host = parsedUrl.host;
export const wbsprotocol = parsedUrl.protocol === "https:" ? "wss://" : "ws://";

export const version = "2.4.0";
export const version_updates = "";

// Google Maps API Key
export const googleApiKey = "AIzaSyABD75PLW3KZYzjDVYi6zp4Ey06lC_rIzM"; // foodoor passed on 25-09-2021

// WebSocket Paths
export const SockethostSuperuser = "/ws/admin_data/admin/";
export const SockethostFranchise = "/ws/franchise_data/";
export const SockethostBranch = "/ws/branch_data/";

// URLs constructed from baseUrl
export const url = baseUrl;
export const socketurlsuper = `${wbsprotocol}${host}${SockethostSuperuser}`;
export const socketurlfranchise = `${wbsprotocol}${host}${SockethostFranchise}`;
export const socketurlbranch = `${wbsprotocol}${host}${SockethostBranch}`;

// Token & User Info
export const token = Cookies.getJSON("foodoor_token")
  ? Cookies.getJSON("foodoor_token").token
  : "";
export const user_id = Cookies.getJSON("foodoor_token")
  ? Cookies.getJSON("foodoor_token").user_id
  : "";
export const username = Cookies.getJSON("foodoor_token")
  ? Cookies.getJSON("foodoor_token").username
  : "";

// Role Permissions & Info
export const is_superuser = Cookies.getJSON("foodoor_token")
  ? Cookies.getJSON("foodoor_token").is_superuser
  : false;

const pickedByAdmin = is_superuser ? readPickedFranchise() : null;
export const picked_franchise_id = pickedByAdmin ? pickedByAdmin.id : "";
export const picked_franchise_name = pickedByAdmin ? pickedByAdmin.name : "";
export const acts_for_franchise = Boolean(pickedByAdmin);

export const is_franchise_admin = Cookies.getJSON("foodoor_token")
  ? Cookies.getJSON("foodoor_token").is_franchise_admin
  : false;
export const is_franchise_manager = Cookies.getJSON("foodoor_token")
  ? Cookies.getJSON("foodoor_token").is_franchise_manager
  : false;
export const is_franchise_staff = Cookies.getJSON("foodoor_token")
  ? Cookies.getJSON("foodoor_token").is_franchise_staff
  : false;
export const {
  has_franchise_reach,
  works_in_franchise,
  runs_franchise,
  is_back_office,
  sees_all_franchises,
} = roleGroups({
  is_superuser,
  acts_for_franchise,
  is_franchise_admin,
  is_franchise_manager,
  is_franchise_staff,
});

export const is_staff_only = Boolean(
  is_franchise_staff &&
  !is_franchise_admin &&
  !is_franchise_manager &&
  !is_superuser,
);

export const is_deliveryboy = Cookies.getJSON("foodoor_token")
  ? Cookies.getJSON("foodoor_token").is_deliveryboy
  : false;
export const is_shop_admin = Cookies.getJSON("foodoor_token")
  ? Cookies.getJSON("foodoor_token").is_shop_admin
  : false;
export const is_shop_manager = Cookies.getJSON("foodoor_token")
  ? Cookies.getJSON("foodoor_token").is_shop_manager
  : false;
export const is_franchise_accountant = Cookies.getJSON("foodoor_token")
  ? Boolean(Cookies.getJSON("foodoor_token").is_franchise_accountant)
  : false;
export const is_accountant_only = Boolean(
  is_franchise_accountant &&
  !is_superuser &&
  !is_franchise_admin &&
  !is_franchise_manager &&
  !is_franchise_staff &&
  !is_shop_admin &&
  !is_shop_manager,
);
export const branch = Cookies.getJSON("foodoor_token")
  ? Cookies.getJSON("foodoor_token").branch
  : "";
export const franchise = pickedByAdmin
  ? { id: Number(pickedByAdmin.id), name: pickedByAdmin.name }
  : Cookies.getJSON("foodoor_token")
    ? Cookies.getJSON("foodoor_token").franchise_data
    : "";
